/**
 * Après Tab / Shift+Tab, force scrollIntoView(block: 'center') pour que l’élément
 * focusé reste visible (le UA utilise souvent 'nearest', insuffisant en arrière).
 * Hors navigation clavier (souris), ne fait rien. Ignore overlays qui gèrent déjà le scroll.
 */
function shouldSkipKeyboardScrollIntoView(el) {
	if (el.closest('cart-drawer.active')) return true;
	if (el.closest('.js-nav-panel.panel-is-open')) return true;
	const predictive = el.closest('.js-predictive-search');
	if (predictive && !predictive.classList.contains('u-hidden')) return true;
	if (el.closest('clrz-notifications.is-open')) return true;
	return false;
}

export function initKeyboardFocusScrollIntoView() {
	let tabDroveLastFocus = false;

	document.addEventListener(
		'keydown',
		(e) => {
			if (e.key !== 'Tab') return;
			tabDroveLastFocus = true;
		},
		true,
	);

	document.addEventListener(
		'pointerdown',
		() => {
			tabDroveLastFocus = false;
		},
		true,
	);

	document.addEventListener(
		'focusin',
		(e) => {
			if (!tabDroveLastFocus) return;
			tabDroveLastFocus = false;

			const el = e.target;
			if (!(el instanceof HTMLElement)) return;
			if (el === document.body || el === document.documentElement) return;
			if (shouldSkipKeyboardScrollIntoView(el)) return;

			const reducedMotion = window.matchMedia(
				'(prefers-reduced-motion: reduce)',
			).matches;
			const behavior = reducedMotion ? 'auto' : 'instant';

			requestAnimationFrame(() => {
				if (document.activeElement !== el) return;
				el.scrollIntoView({block: 'center', inline: 'nearest', behavior});
			});
		},
		true,
	);
}
